if (!customElements.get('client-name-strip')) {
  customElements.define('client-name-strip', class extends HTMLElement {
    connectedCallback() {
      this.startFrame = requestAnimationFrame(() => this.initialize());
    }

    initialize() {
      if (!this.isConnected || this.controller) return;
      this.viewport = this.querySelector('.client-name-strip__viewport');
      this.group = this.querySelector('.client-name-strip__group');
      if (!this.viewport || !this.group) return;

      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.manual = false;
      this.viewport.scrollLeft = 0;

      this.viewport.addEventListener('focus', () => this.useManualScroll(), options);
      this.viewport.addEventListener('blur', () => { this.manual = false; this.update(); }, options);
      this.viewport.addEventListener('pointerdown', () => this.useManualScroll(), options);
      this.viewport.addEventListener('wheel', (event) => {
        if (event.deltaX || event.shiftKey) this.useManualScroll();
      }, { ...options, passive: true });
      this.viewport.addEventListener('keydown', (event) => {
        const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
        if (!keys.includes(event.key)) return;
        event.preventDefault();
        this.useManualScroll();
        const step = this.viewport.clientWidth * 0.7;
        if (event.key === 'Home') this.viewport.scrollLeft = 0;
        if (event.key === 'End') this.viewport.scrollLeft = this.viewport.scrollWidth;
        if (event.key === 'ArrowLeft') this.viewport.scrollLeft -= step;
        if (event.key === 'ArrowRight') this.viewport.scrollLeft += step;
      }, options);

      this.reducedMotion.addEventListener('change', () => {
        this.manual = document.activeElement === this.viewport;
        this.update();
      }, options);

      this.addEventListener('shopify:block:select', () => this.useManualScroll(), options);
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.viewport);
      this.observer.observe(this.group);
      this.update();
    }

    useManualScroll() {
      this.manual = true;
      this.update();
    }

    update() {
      const distance = this.group.getBoundingClientRect().width;
      const canAnimate = this.dataset.autoScroll === 'true' &&
        !this.reducedMotion.matches && distance > this.viewport.clientWidth + 1;
      const isScrolling = canAnimate && !this.manual;
      this.style.setProperty('--client-scroll-distance', `${distance}px`);
      this.toggleAttribute('data-scrolling', isScrolling);
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.startFrame);
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = null;
      this.removeAttribute('data-scrolling');
    }
  });
}
